import styled from "styled-components";

const Wrapper = styled.nav`
    grid-area: nav;
    width: auto;
    height: 100%;
    background-color: var(--yellow);
`;

export default Wrapper;